export class ListaProcesso {
  itens: ItemProcesso[] = [];
}

export class ItemProcesso{
  id: number;
  titulo: string;
  ultimaMovimentacao: Date;
  cliente: string;
  numero: string;
  status: number;
  pasta: string;
  acao: string;
}
